<template>
    <div class="c-toast" :class="'c-toast--' + toast.type " @click="close()">
        <h5>{{toast.title}}</h5>
        <p>{{toast.text}}</p>
    </div>
</template>

<script>
export default {
    props: {
        toast: {
            type: Object
        }
    },
    data() {
        return {
            timeout: null,
            duration : 5000
        }
    },
    methods: {
        close() {

            if ( this.timeout ) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.$store.dispatch('toasts/remove', this.toast.id);
        }
    },
    mounted() {
        this.timeout = setTimeout( () => {
            this.close();
        }, this.duration);
    }
}
</script>
